var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 70,
    height: 70,
    rx: 21.5,
    fill: "white",
    stroke: "#56AAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 37C31.3261 37 32.5979 36.4732 33.5355 35.5355C34.4732 34.5979 35 33.3261 35 32C35 30.6739 34.4732 29.4021 33.5355 28.4645C32.5979 27.5268 31.3261 27 30 27C28.6739 27 27.4021 27.5268 26.4645 28.4645C25.5268 29.4021 25 30.6739 25 32C25 33.3261 25.5268 34.5979 26.4645 35.5355C27.4021 36.4732 28.6739 37 30 37ZM41.25 37C42.2446 37 43.1984 36.6049 43.9017 35.9017C44.6049 35.1984 45 34.2446 45 33.25C45 32.2554 44.6049 31.3016 43.9017 30.5983C43.1984 29.8951 42.2446 29.5 41.25 29.5C40.2554 29.5 39.3016 29.8951 38.5983 30.5983C37.8951 31.3016 37.5 32.2554 37.5 33.25C37.5 34.2446 37.8951 35.1984 38.5983 35.9017C39.3016 36.6049 40.2554 37 41.25 37ZM25.3125 39.5C24.5666 39.5 23.8512 39.7963 23.3238 40.3238C22.7963 40.8512 22.5 41.5666 22.5 42.3125V42.625C22.5 42.625 22.5 48.25 30 48.25C37.5 48.25 37.5 42.625 37.5 42.625V42.3125C37.5 41.5666 37.2037 40.8512 36.6762 40.3238C36.1488 39.7963 35.4334 39.5 34.6875 39.5H25.3125ZM41.25 46.375C39.7862 46.375 38.665 46.1488 37.8062 45.8025C38.306 44.959 38.6197 44.0184 38.7262 43.0437C38.7384 42.9253 38.7463 42.8065 38.75 42.6875V42.3125C38.7516 41.2653 38.3475 40.2582 37.6225 39.5025C37.665 39.5007 37.7075 39.4999 37.75 39.5H44.75C45.4793 39.5 46.1788 39.7897 46.6945 40.3055C47.2103 40.8212 47.5 41.5207 47.5 42.25C47.5 42.25 47.5 46.375 41.25 46.375Z",
    fill: "#56AAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9a08b7cd05bcb61646f8478b9b2a96e3.svg";
export { ForwardRef as ReactComponent };